import { createSlice } from "@reduxjs/toolkit";
import { getAllConnectionRequest, getAllWholesalerProductList,getWholesalerList,getWholesalerById,getConnectionStatus, checkWholesalerConnectionStatus } from "./ThunkAction";
import { iWholesalerState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iWholesalerState = {
  myWholesalerList: [],
  allWholesalerList: [],
  vendorWholesalerList: [],

  isLoading: false,
  errorMessage: null,

  wholesalerProductList: [],
  resalerRequestList: [],
  wholersalerCategoryList: [],
  wholesalerDetail: null,
  connectionStatus: null,
  pagination: null,
};
export const WholesalerSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetWholesalerState: () => {
      return initialState; 
    },
        clearWholesalerProducts: (state) => {
      state.wholesalerProductList = []; 
      state.wholersalerCategoryList = [];
    },
  },

  extraReducers: (builder) => {
    builder
    .addCase(getWholesalerById.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getWholesalerById.fulfilled, (state, action) => {
      const payload = action.payload;
      if (payload && payload.data) {
        state.wholesalerDetail = payload.data.Wholesaler;
        state.isLoading = false;
      }
    })
    .addCase(getWholesalerById.rejected, (state, action) => {
      state.errorMessage = "Failed to fetch Wholesaler data";
      state.isLoading = false;
    })
      .addCase(getWholesalerList.pending, (state) => {
        state.isLoading = true;
        //  state.wholesalerList = [];
      })
      .addCase(getWholesalerList.fulfilled, (state, action) => {
  const payload = action.payload;
  const searchType = action.meta.arg.search;

  if (payload && payload.data) {
    const data = payload.data.data;

    if (searchType === "mylist") {
      state.myWholesalerList = data;
    }

    if (searchType === "all" || searchType === "browse") {
      state.allWholesalerList = data;
    }

    if (searchType === "vendorlist") {
      state.vendorWholesalerList = data;
    }

    state.isLoading = false;
  }
})
      .addCase(getWholesalerList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Wholesaler data";
        state.isLoading = false;
      })
      .addCase(getAllConnectionRequest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllConnectionRequest.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.resalerRequestList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(getAllConnectionRequest.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Wholesaler data";
        state.isLoading = false;
      })
      // Add cases for getAllWholesalerProductList
  .addCase(getAllWholesalerProductList.pending, (state) => {
    state.isLoading = true;
  })
  .addCase(getAllWholesalerProductList.fulfilled, (state, action) => {
    const payload = action.payload;
    if (payload && payload.data) {
      state.wholesalerProductList = payload.data.data.products; // Update productList with the response
      state.wholersalerCategoryList=payload.data.data.categories;
      state.pagination = payload.data.data.pagination;


      state.isLoading = false;
    }
  })
  .addCase(getAllWholesalerProductList.rejected, (state, action) => {
    state.errorMessage = "Failed to fetch product list"; 
    state.isLoading = false;
  })
  
    // Add cases for getAllWholesalerProductList
    .addCase(getConnectionStatus.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getConnectionStatus.fulfilled, (state, action) => {
      const payload = action.payload;
      if (payload && payload.data) {
        state.connectionStatus=payload.data.data;
        state.isLoading = false;
      }
    })
    .addCase(getConnectionStatus.rejected, (state, action) => {
      state.errorMessage = "Failed to fetch data"; // Handle error for products
      state.isLoading = false;
    })

    .addCase(checkWholesalerConnectionStatus.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(checkWholesalerConnectionStatus.fulfilled, (state, action) => {
      const payload = action.payload;
      if (payload && payload.data) {
        state.connectionStatus = payload.data.data;
        state.isLoading = false;
      }
    })
    .addCase(checkWholesalerConnectionStatus.rejected, (state, action) => {
      // @ts-expect-error
      state.errorMessage = action.payload?.message || "Failed to check connection status";
      state.isLoading = false;
    });
  },
});

export const { resetWholesalerState , clearWholesalerProducts} = WholesalerSlice.actions;

export default WholesalerSlice.reducer;
